import React, { Fragment } from 'react'
import { Table, TableBody, TableCell, TableContainer, TextField, Autocomplete,
   TableHead, TableRow, Paper, TablePagination} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import TableFooter from '@mui/material/TableFooter';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Box from '@mui/material/Box';
import { useState } from 'react';
import styled from 'styled-components';
import AddIcon from '@mui/icons-material/Add';
import CMreadonlyrow from './CMreadonlyrow';
import CMeditablerow from './CMeditablerow';
import { useEffect } from 'react';
import { useAddNewComplMasterMutation, useGetComplMastersQuery, useUpdateComplMasterMutation, useDeleteComplMasterMutation  } from '../../../features/complmaster/complmasterApiSlice';
import SubjectMaster from './SubjectMaster';
import Select from '@mui/material/Select';
import {OutlinedInput, MenuItem, Chip, Stack} from '@mui/material';
import { useGetAssetMastersQuery } from '../../../features/assetmasterApiSlice/assetmasterApiSlice';
import {HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles';
import {TableContStyle, TableHeadStyle } from '../../../Styles/TableStyles';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ExcelDownload from '../../../data/exceldownload';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Addcategcont =styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
`
const Addcategform = styled.form`
  display: flex;
  margin:10px;
  align-items: center;
  justify-content:space-between;
`
const Displaydiv1 = styled.div`

`
const HeadingField = styled.div`
  font-weight: bold;
  margin-bottom:20px;
  margin-top:15px;
`

const AssetCategoryWrapper = styled.div`

`
const Label = styled.label`
    width: 140px;
    margin: 10px;
`
const ComplaintCategoryWrapper =styled.div`
  display: flex;

`
const SubmitButton = styled(CommonButton)`
height:"40px";
margin-top:"0px";
margin-bottom:"0px";
`
const Button2Div =styled.div`
  display: flex;
  justify-content: end;
`

const tableFontSize = 18;

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };


  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};


export default function CustomPaginationActionsTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [values, setValues] =useState({
    Category:"",
    Asset:[]  
  });

  const {complmaster} = useGetComplMastersQuery("complList", {
    selectFromResult: ({ data }) => ({
      complmaster: data?.entities
    }),
  })
  const {assetmaster} = useGetAssetMastersQuery('arg', {
    selectFromResult: ({ data }) => ({
        assetmaster: data?.entities
    }),
  })  
  const [addNewComplMaster] = useAddNewComplMasterMutation();
  const [updateComplMaster] = useUpdateComplMasterMutation();
  const [deleteComplMaster] = useDeleteComplMasterMutation();
  const [tabledata, setTabledata]= useState([]);
  const [categProp, setCategProp]= useState();
  const [categPropId, setCategPropId]= useState();
  const [editCategory, setEditCategory]=useState(null);
  const [editFormData, setEditFormData]=useState({});
  const [addCategData, setAddCategData] = useState({});
  const [assetCategory, setAssetCategory]=useState([]);
  const [sentData, setSentData ]= useState(0);
  const [subject, setSubject] = useState({});
  const [subCategPage, setSubCategPage] = useState(false)

     // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onClickAddSubCateg = (e,k) => {
    setCategProp(tabledata[k]?.Category)
    setCategPropId(tabledata[k]?.id)
    setSubCategPage(true)       
  }
 console.log(complmaster)

  const onSubmit = async (event) =>{
    event.preventDefault();
    try{
      let bodyobject ={"Category":addCategData.Category, "ApplAssetCateg":addCategData.assetCategories, "AppAssets":addCategData.applicableAssets, "Subject":[]};
      const found = Object.values(complmaster).some(el => el.Category === editFormData.Category);
      
   if(!found && addCategData?.Category?.length ){
      const res = await addNewComplMaster(bodyobject) ;
      setAddCategData({});
      setSentData(sentData+1);
      }
    } catch(err){console.log(err)}
  }

  const onClickEdit = (e,k,row)=>{
    setEditCategory(k+1);
  }

  const onChangeAddCateg = (event, newValue,name) =>{
    let temp ={...addCategData}
    if(event.target.name === "Category"){
      temp = {...temp, [event.target.name]:event.target.value}
    }
    if(name === "assetCategories"){
      temp = {...temp, [name]:newValue}
    }
    if(name === "applicableAssets"){
      if(newValue.includes("All Assets")){
        temp = { ...temp, [name]: ["All Assets"] };
      } else {
        temp = {...temp, [name]:newValue}
      }
    }
    setAddCategData(temp);
  }

  const onChangeEditCateg = (e,k,id, newValue, name) =>{
    let tempEditFormData = structuredClone(editFormData);
    let tempIndex = tempEditFormData.findIndex(x => x._id === id )

    if(e.target.name === "Category"){
      tempEditFormData[tempIndex].Category = e.target.value;
      setEditFormData(tempEditFormData);
    }
    if(e.target.name === "Subject"){
      tempEditFormData[tempIndex].Subject[subject[`subject${editCategory-1}`]?.index] = e.target.value;
      setEditFormData(tempEditFormData);
    }
    if(name === "ApplAssetCateg"){
      tempEditFormData[tempIndex].ApplAssetCateg = newValue;
      console.log(tempEditFormData)
      setEditFormData(tempEditFormData);
    }

    if(name === "AppAssets"){
      if(newValue.includes("All Assets")){
        tempEditFormData[tempIndex].AppAssets = ["All Assets"] ;
      } else {
        tempEditFormData[tempIndex].AppAssets = newValue;
      }
      setEditFormData(tempEditFormData);
    }
  }
console.log(editFormData)
  const handleEditFormSubmit = async (e) =>{
    e.preventDefault();
    try{
    setEditCategory(null);
    setSubject({})
    const id = tabledata[((page)*(rowsPerPage))+(editCategory-1)].id;
    let body = editFormData.find(x => x.id === id);
    console.log(body)
    const response = await  updateComplMaster(body)
    }catch(err){}
  }
  

  const handleCancelClick = (e,k) => {
    setEditCategory(null);
    setSubject({});
  };

  const handleDeleteClick = async (e,k,id) => {
    e.preventDefault();
    let body = {"id":id}
    const result = await deleteComplMaster(body);
    setSentData(id);    
  };  
  
  const onChangeSub = (event, newValue, name,k) =>{
    let tempObject = {};
    tempObject = {...tempObject, [name]:{"data":newValue, "index":tabledata[k].Subject.indexOf(newValue)}} 
    setSubject(tempObject);
  }
  const onClickBackArrow = () =>{
    setSubCategPage(false);
  }

  {console.log(subject)}

  useEffect(()=>{
    if(complmaster){
      const complmasterArray = Object.values(complmaster);
      setTabledata(complmasterArray);
      setEditFormData(complmasterArray);
    }
  },[complmaster, subject])

   
  return (
    <>
    { !subCategPage ?
    <Displaydiv1>

      <HeadingWrap>
        <Span>Add New Complaint Category</Span>
      </HeadingWrap>

    <ComplaintCategoryWrapper>

    <Addcategform onSubmit={onSubmit}>
      <TextField
        id="outlined-basic"
        size='small'
        name='Category'
        onChange={(event, newValue) => onChangeAddCateg(event, newValue)}
        label="Enter New Category"
        value={addCategData.Category  || ""}
        variant="outlined"
        sx={{backgroundColor:"white", width:"200px", height:"40px"}}
      />
      <Autocomplete
        multiple
        id="combo-box-demo"
        size='small'
        options={assetmaster ? (Object.values(assetmaster)?.map(x=>x.Category)):[]}
        sx={{backgroundColor:"white", width:"250px", marginLeft:"20px", marginRight:"20px",height:"40px"}}
        // getOptionLabel={(option) => option.title}
        value={addCategData?.assetCategories? addCategData?.assetCategories:[]}
        onChange={(event, newValue) =>onChangeAddCateg(event, newValue, "assetCategories")}
        renderInput={(params) => ( 
          <TextField
            {...params}
            variant="outlined"
            label="Select Appl Asset Categories"
            placeholder="Favorites"
          />
        )}
      />
      {addCategData?.assetCategories?.length? <Autocomplete
        multiple
        id="combo-box-demo"
        size='small'
        options={(assetmaster && (!addCategData?.applicableAssets?.includes("All Assets")))? ["All Assets"].concat(Object.values(assetmaster)
          .filter(item => addCategData?.assetCategories?.includes(item.Category))
          .flatMap(item => item.Asset.map(asset => asset.Name))):[]}
        sx={{backgroundColor:"white", width:"250px", marginLeft:"20px", marginRight:"20px",height:"40px"}}
        // getOptionLabel={(option) => option.title}
        value={addCategData?.applicableAssets? addCategData?.applicableAssets:[]}
        onChange={(event, newValue) =>onChangeAddCateg(event, newValue, "applicableAssets")}
        renderInput={(params) => ( 
          <TextField
            {...params}
            variant="outlined"
            label="Select Applicable Assets"
            placeholder="Favorites"
          />
        )}
      />:null}
    <SubmitButton type='submit'>Submit</SubmitButton>  
    </Addcategform>

    
    </ComplaintCategoryWrapper>

    <form onSubmit={handleEditFormSubmit}>

    <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}  >
      <Table  aria-label="custom pagination table">
      <TableHead sx={{ backgroundColor: TableHeadStyle.backgroundColor}}>
        <TableRow>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"5%"}}} align="left">Sl.No.</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"20%"}}} align="left">Complaint Category</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"20%"}}} align="left">Subject</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"20%"}}} align="left">Applicable Categories</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"20%"}}} align="left">Applicable Assets</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"20%"}}} align="left">Edit</TableCell>
        </TableRow>
        {/* <TableRow>
          <TableCell ></TableCell>
          <TableCell >
            <TextField sx={{background:"white"}}  name='type' onChange={handleSearchChange} label="Search Office Type" size="small"  variant="outlined" />
          </TableCell>
          <TableCell >  
            <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                onChange={(event, newValue) => handleSearchChange(event, newValue, "level")}
                size="small"
                value={searchData.level}
                options={officetype? Object.values( officetype)?.map(x=> x.level).filter((item,index)=> Object.values(      officetype)?.map(x=> x.level).indexOf(item) === index).sort((a, b) => {
                  // Extract numeric part from strings
                  let numA = parseInt(a.match(/\d+/)[0]);
                  let numB = parseInt(b.match(/\d+/)[0]);                  
                  return numA - numB;
                }):[]}      
                disableCloseOnSelect
                getOptionLabel={(option) => String(option)}
                renderOption={(props, option, { selected }) => (
                  <li {...props} style={{ fontSize: '2 rem' }}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 0, marginLeft:0 }}
                      checked={selected}
                    />
                    {option}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Search Level"  sx={{background:"white", width:"70%"}} />
                )}
                />
          </TableCell>
          <TableCell >
            <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                onChange={(event, newValue) => handleSearchChange(event, newValue, "unitHead")}
                size="small"
                value={searchData.unitHead}
                options={officetype? Object.values(officetype)?.map(x=> x.unitHead).flat().filter((item,index)=> Object.values(officetype)?.map(x=> x.unitHead).flat().indexOf(item) === index).sort(): []}
                disableCloseOnSelect
                getOptionLabel={(option) => String(option)}
                renderOption={(props, option, { selected }) => (
                  <li {...props} style={{ fontSize: '2 rem' }}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 0, marginLeft:0 }}
                      checked={selected}
                    />
                    {option}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Search UnitHead Designations"  sx={{background:"white", width:"70%"}} />
                )}
                />
          </TableCell>
          <TableCell ></TableCell>
        </TableRow> */}
      </TableHead>

      <TableBody>
        {(rowsPerPage > 0
          ? tabledata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage): tabledata
          ).map((row, key) => ( 
            <Fragment key={key*2}>
              {editCategory=== key+1 ?
              
               <CMeditablerow row={row} k={key} editFormData={editFormData} subject={subject}
                handleCancelClick={handleCancelClick} page={page} rowsPerPage={rowsPerPage} SubmitButton={SubmitButton}
                onChangeEditCateg={onChangeEditCateg} assetCategory={assetCategory} assetmaster={assetmaster}
               />

                :<CMreadonlyrow row={row} k={key} tabledata={tabledata} onClickEdit={onClickEdit}
                  handleDeleteClick= {handleDeleteClick} onClickAddSubCateg={onClickAddSubCateg}
                  onChangeSub={onChangeSub} page={page}rowsPerPage={rowsPerPage} editCategory={editCategory}
                  tableFontSize={tableFontSize} SubmitButton={SubmitButton} subject={subject}                
                />
                 }
            </Fragment>                   
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={tabledata.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    </form>
    </Displaydiv1>:

    <SubjectMaster categProp={categProp} categPropId= {categPropId} onClickBackArrow={onClickBackArrow}
    setSentData={setSentData} complmaster={complmaster} deleteComplMaster={deleteComplMaster} Button2Div={Button2Div} ExcelDownload={ExcelDownload}/>
    }    
    </>
  );
}